<template>
  <TableTemplate class="OverviewOrder"
    v-model="mappedContent"

    :columns="tableColumns"
    :columnVariables="tableColumnVariables"
    :capitalize="capitalize"
    :skeletonClass="skeletonClass"

    :page="page"
    :max="max"
    :enable-sorting="true"

    @update-column-order="updateColumnOrder"
    @set-page="v => page = v"
    :on-row-click="viewWhosaleOrder"

    ref="table"
  >
    <template #above>
      <TableHeader
        title="Orderpicken"
        :alwaysShowMultiSelectCheckbox="false"
        :refetch="refetch"

        @customize-layout="customizeLayout"
      >
        <template #header-buttons-before="props">
          <slot name="header-buttons-before" v-bind="props"></slot>
        </template>
      </TableHeader>
      <div class="d-flex">
        <TableMainSearchField v-model="search"/>

        <FormSearchSelector class="ml-2 website-search"
          v-model="site"
          id="website"
          placeholder="Zoek website..."
          endpoint="/api/websites"
          titleField="domainname"

          :infinite-scrolling="true"
          :table="true"

          v-slot="item"
        >
          <div class="p-1 item">
            {{ item.domainname }}
          </div>
        </FormSearchSelector>

        <RefreshBtn
          :loading="isLoadingTableResult"
          @click.native="refresh"
        />
      </div>
      <CardTabs class="card-tabs"
        v-model="state"
        :tabs="tabs"
      />
    </template>

    <template #cell-status="{value}">
      <button
        type='button'
        class="btn"
        :class="value === 'active' ? 'btn-success' : 'btn-danger'"
      >
        {{ value }}
      </button>
    </template>

    <template #cell-orderAmount="{value}">
      <span class="order-amount">
        {{ `€ ${(value + "").replace(/\./, ",")}` }}
      </span>
    </template>

    <template v-if="loaded" #row-action="{item}">
      <TableActionDropdown class="drop" :item="item" :options="options(item, freshRefetch)"/>
    </template>

    <template #cell-orderNumber="{value}">
      <CopyableElement :skeleton-class="skeletonClass"
        :value="value"
        :message="`Succesvol ${value} ordernummer gekopieerd!`"
      >
        {{ value }}
      </CopyableElement>
    </template>

    <template #empty-state>
      <EmptyStatePlaceholder
        :title="state === 'campaign' ? 'THe' : 'Geen advertentiegroepen gevonden'"
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" height="600" width="600"><g><line x1="7" y1="0.5" x2="7" y2="4.5" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></line><line x1="8.5" y1="11" x2="11" y2="11" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></line><path d="M.5,4.5h13a0,0,0,0,1,0,0v8a1,1,0,0,1-1,1H1.5a1,1,0,0,1-1-1v-8A0,0,0,0,1,.5,4.5Z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path><path d="M.5,4.5,2,1.61A2,2,0,0,1,3.74.5h6.52a2,2,0,0,1,1.79,1.11L13.5,4.5" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path></g></svg>
      </EmptyStatePlaceholder>
    </template>


  </TableTemplate>
</template>

<script>

import TableTemplate from 'src/layout/Table/TableTemplate'
import tableFieldOptions from "src/mixins/tableFieldOptions"
import TableSearchField from "src/components/Inputs/TableSearchField.vue"
import TableActionDropdown from "src/components/Inputs/TableActionDropdown.vue"
import FormSelect from "src/components/Inputs/FormSelect.vue"
import EmptyStatePlaceholder from "src/layout/EmptyStatePlaceholder.vue"
import CardTabs from "src/layout/CardTabs.vue"
import TableCell from "src/components/Table/TableCell.vue"
import TableDatePickerField from '../components/Inputs/TableDatePickerField.vue'
import TableMainSearchField from '../layout/TableMainSearchField.vue'
import CopyableElement from '../layout/CopyableElement.vue'
import MultiplePageSizesSelection from '@/layout/Table/MultiplePageSizesSelection.vue'
import TableHeader from "src/components/Product/ProductTable/TableHeader.vue"
import HeaderButton from "src/components/Inputs/HeaderButton.vue"
import RefreshBtn from '../layout/RefreshBtn.vue'
import FormSearchSelector from '../components/Inputs/FormSearchSelector.vue'

import table from "src/mixins/table"
import keepScroll from "src/mixins/keepScroll"

import faker from 'faker'

export default {
  metaInfo: {
    title: "Orderpicken",
  },
  components: {
    HeaderButton,
    CardTabs,
    TableHeader,
    TableMainSearchField,
    RefreshBtn,
    MultiplePageSizesSelection,
    TableCell,
    TableDatePickerField,
    CopyableElement,

    TableActionDropdown,
    FormSelect,
    FormSearchSelector,
    TableTemplate,
    TableSearchField,
    EmptyStatePlaceholder,
    FormSearchSelector,
  },
  mixins: [
    tableFieldOptions,
    keepScroll,
    table({
      pageReference: 'wholesale',

      defaultColumnSizes: {

      },
      columnTranslationMaps: {
        "Remark": "remark",
        "id": "uid",
        "Order number": "orderNumber",
        "Website": "site",
        "Order date": "orderDate",
        "Order Amount": "orderAmount",
        // "Customer": "customer",
        // "Email": "email",
        // "State": "state",
      },
      defaultColumns: [
        "Remark", "id", "Order number", "Website", "Order date"
        // "Customer", "Email", "State" "Order amount",
      ],

      page_size: 15,
      params: {
        site: "",
        search: "",

        page_size: 20,
        state: "packing_slip",
      },
      routeTriggers: ["state"],
      route: vm => `/api/wholesale/orders?type=${vm.state}`
    }),
  ],
  data() {
    return {
      meta: {},

      /**
       * [ Mixin keepScroll ] - localStorageKey: Unique key(one per page) that will be used as a reference to set/get the element's distance from the top
       */
      localStorageKey: "wholesale"
    }
  },
  mounted() {
    setTimeout(() => {
      if (this.$route.query.refresh) {
        this.refresh()
      }
    }, 1000)
  },
  methods: {
    async addOrder() {
      this.$pushModal({
        modal: "AddOrder",
        toBind: {
          callback: this.freshRefetch,
        }
      })
    },

    async cancelOrder(uid) {
      this.$handlePromise(
        this.axios.delete(`/api/orders/${uid}`)
      )
      this.$success("Bestelling geannuleerd!")
      this.freshRefetch()
    },
    viewWhosaleOrder(item) {
      if (this.removeCursor) return;

      const referenceRowTarget = document.getElementById(`table-row-${item.uid}`)
      referenceRowTarget && this.setLocalStorageTopDistance({ target: referenceRowTarget})

      this.$router.push(`/admin/wholesale-orders/${item.uid}`).catch(()=>{})
    },
    getWebsiteList(websites) {
      return websites.reduce((str, site) => {
        return !str.length ? `, ${site.domainname}` : site.domainname
      }, "")
    },
    confirmDelete(item) {
      this.$confirmAction(
        () => this.cancelOrder(item.uid),
        {
          title: "Annuleer bestelling",
          description: `Are you sure you want to cancel the <b>${item.email || item.customer}</b> order?`,
          buttonSave: "Annuleren",
        }
      )
    },
    options(item, freshRefetch) {
      const getDeleteObj = (name, success) => ({
        click: async () => {
          if (await this.$handlePromise(
            this.axios.delete(`/api/wholesale/orders/${item.uid}`)
          )) {
            this.$success(success)
            freshRefetch()
          }
        },
        id: "cancel",
        name,
        icon: "nc-icon nc-simple-remove",
      })

      switch (this.state) {
        case "packing_slip": {
          return [
            {
              click: () => this.viewWhosaleOrder(item),
              id: "edit",
              name: "Groothandelsbestelling bewerken",
              icon: "nc-icon nc-settings-tool-66"
            },
            ...(
              this.isAdmin ? [
                getDeleteObj("Groothandelsbestelling annuleren", "Bestelling geannuleerd!")
              ] : []
            ),
            {
              click: () => this.printOrder(item),
              id: "print",
              name: "Print",
              icon: "nc-icon nc-paper-2"
            },
          ]
        }
        case "invoice_input": {
          return this.isAdmin ? [
            getDeleteObj("Factuur verwijderen!", "Factuur verwijderd!")
          ] : []
        }
      }
    },
    isOlderThanTwoDays(orderDate) {
      const diff = new Date().getTime() - new Date(orderDate).getTime()
      return diff > MILISECONDS_IN_TWO_DAYS
    },
    async printOrder(item) {
      const url = `/api/wholesale/orders/${item.uid}/packing-slip`
      window.open(url, '_blank');
    }
  },
  computed: {
    tabs() {
      return [
        {
          name: "Pakbon",
          id: 'packing_slip',
        },
        {
          name: "Factuur",
          id: 'invoice_input',
        },
      ]
    },
    sortOptions() {
      return [
        {
          str: "Asc",
          value: "asc",
        },
        {
          str: "Desc",
          value: "desc",
        },
      ]
    },
    isAdmin() {
      return this.$store.state.user.role === 'ADMIN'
    },

    filteredResult() {
      let data = this.result
      data = (this.state !== "campaign" ? data.adGroups : data.campaigns)
      if (!data || !data.length) return;

      const arr = data.map(item => ({ ...item.campaign, ...item.metrics }))
      const property = this.sort
      const order = this.order

      const names = ["name", "resource_name"]
      property && arr.sort((a, b) => {
        if (names.includes(property)) {
          return order === "asc"
            ? a[property].localeCompare(b[property])
            : b[property].localeCompare(a[property])
        }

        return this.sortNumber(a[property], b[property], false, order)
      })

      return arr
    },
    mappedContent() {
      return this.tableResult

      /* if (this.state === "campaign") return

      return arr.map(item => ({
        ...item,
        isOlderThanTwoDays: this.isOlderThanTwoDays(item.orderDate),
      })) */
    },
    table() {
      return this.$refs.table
    },
    capitalize() {
      return [false, false, false, false, false, false, false]
    },
  },
  watch: {
    state() {
      this.page = 1
    },
  },
}

</script>

<style>

.OverviewOrder tr > td.first-child > span {
  display: block;
  padding-left: 14px !important;
}

</style>

<style scoped>

.item {
  transition-duration: .15s;
}

.item:hover {
  background-color: rgba(245,245,245);
}

.older-than-two-days-warning {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
}

.card-tabs {
  transform: translateY(9px);
}

.card-title {
  margin-top: 0;
  margin-bottom: 18px;
}

.website-search {
  width: 100%;
}

.website-search::v-deep input {
  height: 34px;
}

@media (min-width: 992px) {
  .website-search {
    width: initial;
  }
}

</style>
